const initialState = {
    // Handles both getting and setting mass email options
	optionsLoading: false,
    optionsError: '',
    optionsSuccess: '',
    options: {},
    // Handles both getting and setting notion options
    noticeOptionsLoading: false,
    noticeOptionsError: '',
    noticeOptionsSuccess: '',
    noticeOptions: {},
    // Handles submission of email button
    submissionLoading: false,
    submissionError: '',
    submissionSuccess: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case "MASS_EMAIL_OPTIONS_IS_LOADING":
            return {
                ...state,
                optionsLoading: true
            };
        case "MASS_EMAIL_OPTIONS_HAS_ERROR":
            return {
                ...state,
                optionsLoading: false,
                optionsError: action.error,
                optionsSuccess: ''
            };
        case "MASS_EMAIL_OPTIONS_SUCCESS":
            return {
                ...state,
                optionsLoading: false,
                optionsError: '',
                options: {
                    ...action.data.options,
                    sectors: action.data.sectors
                },
                optionsSuccess: action.data.message || ''
            };
        case "NOTICE_OPTIONS_IS_LOADING":
            return {
                ...state,
                noticeOptionsLoading: true
            };
        case "NOTICE_OPTIONS_HAS_ERROR":
            return {
                ...state,
                noticeOptionsLoading: false,
                noticeOptionsError: action.error,
                noticeOptionsSuccess: ''
            };
        case "NOTICE_OPTIONS_SUCCESS":
            return {
                ...state,
                noticeOptionsLoading: false,
                noticeOptionsError: '',
                noticeOptions: action.data.notice_options,
                noticeOptionsSuccess: action.data.message || ''
            };
        case "MASS_EMAIL_SUBMISSION_IS_LOADING":
            return {
                ...state,
                submissionLoading: true
            }
        case "MASS_EMAIL_SUBMISSION_HAS_ERROR":
            return {
                ...state,
                submissionLoading: false,
                submissionError: action.error,
                submissionSuccess: ''
            }
        case "MASS_EMAIL_SUBMISSION_SUCCESS":
            return {
                ...state,
                submissionLoading: false,
                submissionError: '',
                submissionSuccess: action.data.message
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/reviewsEmail.js